import React from "react";
import moment from 'moment'
import PlaceHolderImage from "../../assets/candle-placeholder.png";

const UpdateOrderCard = ({ orderId, order, handleChangeView, confirmCancel}) => {
  return (
    <div className="ct-modal__appointment-card">
      <div className="ct-modal__appointment-card--content">
        <div style={{textAlign: 'center'}}>Cancel your {order.title} appointment starting {moment(order.date).format('MMMM D, YYYY')} between {moment(order.start_time).format('h:mm A')} - {moment(order.end_time).format('h:mm A')}?</div>
        <div className="ct-updatecard__actions" style={{justifyContent: 'center', marginBottom: 20}}>
          <button className="ct-modal__button" onClick={confirmCancel}>Cancel Appointment</button>
          <button className="ct-modal__button" onClick={() => handleChangeView('orders')}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateOrderCard;
